/**
 * Created by noOne on 01/12/2017.
 */
"use strict";

import Betty from "./Betty";
import Present from "./Present";

export default class Santa extends Betty {
    /**
     * @param holder {*|PIXI.projection.Container2d} - optional holder to add to
     */
    constructor(holder) {
        super("santa", holder);

        /**
         * @type {*|PIXI.projection.Container2d}
         * @private
         */
        this._container3D = holder;

        /**
         * @type {number}
         * @private
         */
        this._dropPresentLength = 3;

        /**
         * @type {number}
         * @private
         */
        this._dropPresentTime = 0;

        /**
         * @type {number}
         * @private
         */
        this._numPresents = 1;

        //this.init();
        this.view.y = -300;
        this._isReal = true;

    }

    update() {

        if (!this._target || this._sleep || this._pause || !this.view.visible) return;

        let dist = Common.distance(this.x, this.y, this._target.x, this._target.y);
        if (dist === 0) dist = 1; //ovoid NaN on divide by zero

        this._dx = (this._target.x - this.x) / dist;//get each component of our direction vector and normalise with the length
        this._dy = (this._target.y - this.y) / dist;

        this._targetVelocity = new PIXI.Point(this._dx * this._moveSpeed, this._dy * this._moveSpeed);

        const force = 15;

        if (this._velocity.x < this._targetVelocity.x) {
            this._velocity.x += force;
        } else if (this._velocity.x > this._targetVelocity.x) {
            this._velocity.x -= force;
        }

        if (this._velocity.y < this._targetVelocity.y) {
            this._velocity.y += force;
        } else if (this._velocity.y > this._targetVelocity.y) {
            this._velocity.y -= force;
        }

        this.x += this._velocity.x * P3.deltaTime;//scale by move speed and multiply by dt before addition
        this.y += this._velocity.y * P3.deltaTime;

        if (dist < 10) {
            this._path.pop();
            this.setTarget();
        }

        //--drop present timer--//
        this._dropPresentTime += deltaTime;
        if (this._dropPresentTime > this._dropPresentLength) {
            this.dropPresent();
        }
    }

    dropPresent() {

        if (this._numPresents < 1 || Common.healthInLevel) {
            return;
        }

        Common.healthInLevel = true;

        this._numPresents--;

        const present = new Present(null, this._container3D);

        present.view = P3.createSprite("santa_heart", present);
        present.x = this.x;
        present.y = this.y;
        present.view.y = this.view.y - 150;
        present.view.anchor.set(0.5, 0);
        present.view.width = 150;
        present.view.height = 150;
        this._sleep = true;

        TweenMax.to(present.view, 1, {
            y: -95,
            ease: Bounce.easeOut,
            delay: 0.2,
            onComplete: ()=> {
                this._dropPresentTime = 0;
                this._sleep = false;

                present.addChild(present.view);
                present.view.y = -95;
                present.reveal();
            }
        });

    }

    setTarget() {
        if (this._path.length > 0) {
            this._target = this._path[this._path.length - 1];
        } else {
            this._pathComplete();
        }
    }

    /**
     * @private
     */
    _pathComplete() {

        this.goToSleep();

        this._dropPresentTime = 0;
        this._numPresents = 1;
        this._dropPresentLength = P3.math.random(2, 3.5);

        this._target = null;
        this.view.interactive = true;

        const index = Common.activePathIds.indexOf(this.pathId);
        Common.activePathIds.splice(index, 1);

        this._path.length = 0;

    }
}